import { Trans } from "react-i18next"

import util from "utils/utils"

export default function DiscussionReactedContent({ ownerGroup = { name: "Undefined" }, events }) {
  return (
    <Trans i18nKey="notifications.groupDiscussionReacted">
      <b>{{ name: util.getEventNames(events) }}</b>
      reacted to your post in the group discussion for
      <b>{{ group: ownerGroup.name }}</b>
    </Trans>
  )
}
